import React from "react";
import { useAlert } from "../../../../../Context/AlertContext";
import useToastError from "../../../../../hooks/useErrorToast";
import useSWRMutation from "swr/mutation";
import { liveClassItemsUrls } from "../../../../../Api/Auth/ApiUrls";
import { toast } from "react-toastify";
import { sendDeleteRequestAuth } from "../../../../../Api/swrConfig";
import TableRow from "../../../../../Components/Common/TableRow";
import TableData from "../../../../../Components/Common/TableData";
import TableRowPerAction from "../../../../../Components/Common/TableRowPerAction";
import { convertToLocalDateTime } from "../../../../../utils/convertToLocalDateTime";
import { useParams } from "react-router-dom";

const LiveClassItemsRow = ({ row, mutate, onEditClick }) => {
  const params = useParams();
  const { id } = params;
  const { showAlert, setIsLoading } = useAlert();
  const { showErrorToast } = useToastError();
  const { trigger: deleteTrigger } = useSWRMutation(
    liveClassItemsUrls.delete(id, row._id),
    sendDeleteRequestAuth,
    {
      onSuccess: () => {
        setIsLoading(false);
        toast.success("Success");
        mutate();
      },
      // If error occurred - make delete false
      onError: (error) => {
        setIsLoading(false);
        showErrorToast(error);
      },
    }
  );
  const handleDelete = () => {
    showAlert(
      `Are you sure you want to delete the live class "${row.title}"?`,
      async () => {
        setIsLoading(true);
        await deleteTrigger(row._id);
      }
    );
  };

  return (
    <>
      <TableRow key={row._id}>
        <TableData>{row.title}</TableData>
        <TableData>{row.duration}</TableData>
        <TableData>
          {convertToLocalDateTime(row.date)?.split(",")?.[0]}
        </TableData>
        <TableData>{row.time}</TableData>
        <TableData>{row.instructor}</TableData>
        <TableData>
          <span className="block w-40 truncate">{row.meetingLink}</span>
        </TableData>
        <TableData>
          <span className="block w-40 truncate">{row.recordingLink}</span>
        </TableData>
        <TableData>{convertToLocalDateTime(row.createdAt)}</TableData>
        <TableRowPerAction
          onEdit={() => onEditClick(row)}
          onDelete={handleDelete}
        />
      </TableRow>
    </>
  );
};

export default LiveClassItemsRow;
